import { Link } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { BRAND_MARK_SIZE_PX } from '../config/brand-mark';

type BrandLinkProps = Omit<ComponentProps<typeof Link>, 'to'> & {
  className?: string;
  to?: string;
  onDark?: boolean;
};

const baseClasses = 'brand-link inline-flex items-center';

export function BrandLink({
  className,
  to = '/',
  onDark = false,
  ...rest
}: BrandLinkProps) {
  return (
    <Link
      to={to}
      className={`${baseClasses} ${onDark ? 'brand-wordmark-on-dark' : ''} ${className ?? ''}`.trim()}
      {...rest}
    >
      <img
        src="/mark.svg"
        alt="upCaret"
        width={BRAND_MARK_SIZE_PX}
        height={BRAND_MARK_SIZE_PX}
        className="h-8 w-8 shrink-0 object-contain object-left"
      />
      <span className="brand-wordmark text-xl sm:text-2xl">
        upCaret
      </span>
    </Link>
  );
}
